import type { ListItem } from "../../components/List/List"
import { Tables } from "../Table/Tables"
import { MemoryClass } from "./MemoryClass"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTable } from "@fortawesome/free-solid-svg-icons"
import i18next from "i18next"

export class MemoryTables extends MemoryClass<Tables> {
  setList(items: Tables[]): void {
    this.listData = items
  }

  protected cloneEntity(item: Tables): Tables {
    return new Tables({ ...item })
  }

  getListCards(all: boolean) {
    var cards: ListItem[] = []
    let count = 0

    this.listData.forEach((ss) => {
      if (all || ss.status === EEnableStatusType.Active) {
        cards.push(this.getCard(ss, count))
      }
    })

    count++

    return cards
  }

  getCard(ss: Tables, count: number): ListItem {
    const enable = ss.status === EEnableStatusType.Active

    const occupied = ss.isOccupied || ss.hasCustomer

    const cardColor = occupied
      ? "bg-red-50 border-2 border-red-300 hover:shadow-md hover:scale-[1.01]"
      : enable
        ? "bg-white border border-slate-200 hover:shadow-md hover:scale-[1.01]"
        : "bg-slate-100 border border-slate-200 opacity-80"

    const tableNumberColor = occupied ? "bg-red-600" : enable ? "bg-slate-500" : "bg-slate-400"

    return {
      isDisable: !enable,
      id: ss.id,
      title: ss.number.toString(),
      linkImage: "",
      index: count,
      dataFilter: [
        ss.id.toString(),
        ss.number.toString(),
        ss.description,
        ss.status.toEnableStatusTypeString(),
        occupied ? i18next.t("tables:status_occupied") : i18next.t("tables:status_free"),
      ],
      children: (
        <div
          className={`
          flex items-center justify-between
          p-3
          rounded-2xl
          transition-all duration-200
          ${cardColor}
        `}
        >
          <div className="flex items-center gap-4">
            <div
              className={`
              w-14 h-14
              flex items-center justify-center
              rounded-full
              text-white
              text-2xl font-bold
              ${tableNumberColor}
            `}
            >
              {ss.number}
            </div>

            <div className="flex flex-col gap-1">
              <span className="font-semibold text-gray-800 text-sm uppercase">
                <FontAwesomeIcon icon={faTable} className="mr-1" />
                {i18next.t("components:label_tables")}
              </span>

              {ss.description && <span className="text-xs text-gray-500">{ss.description}</span>}

              <span className="text-xs text-gray-500">
                👥 {ss.currentPeopleCount} • {ss.activeOrderCount} {i18next.t("tables:label_open_tabs")}
              </span>
            </div>
          </div>

          <div className="flex flex-col items-end gap-2">
            {enable ? (
              <span className="px-3 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-700">Ativa</span>
            ) : (
              <span className="px-3 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-600">Inativa</span>
            )}

            <span
              className={`px-3 py-1 text-xs font-semibold rounded-full ${occupied ? "bg-red-100 text-red-700" : "bg-white text-slate-700 border border-slate-300"}`}
            >
              {occupied ? i18next.t("tables:status_occupied") : i18next.t("tables:status_free")}
            </span>
          </div>
        </div>
      ),
    }
  }

  protected getItemId(item: Tables): number {
    return item.id
  }
}
